import $ from 'jquery'

import initKnowUsButton from './events'
import initVenobox from './venobox'
import initGoogleMaps from './map'

$(() => {
    initKnowUsButton() // KnowUsButton scroll
    initVenobox() // ImageSlider
    initGoogleMaps() // Map
})
